import { render, staticRenderFns } from "./BankWithdrawForm.vue?vue&type=template&id=da9804f2&scoped=true"
import script from "./BankWithdrawForm.vue?vue&type=script&lang=js"
export * from "./BankWithdrawForm.vue?vue&type=script&lang=js"
import style0 from "./BankWithdrawForm.vue?vue&type=style&index=0&id=da9804f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9804f2",
  null
  
)

export default component.exports